import { AssetOrder } from '../entities/asset-order';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';


export class AssetOrderRequest extends BaseRequest {
  assetOrder : AssetOrder;
  constructor(userInfo : UserInfo){    
    super(userInfo);
    this.assetOrder = new AssetOrder();
  }
}